import { render, staticRenderFns } from "./OrganizationCreate.vue?vue&type=template&id=723e6233&"
import script from "./OrganizationCreate.vue?vue&type=script&lang=js&"
export * from "./OrganizationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('723e6233')) {
      api.createRecord('723e6233', component.options)
    } else {
      api.reload('723e6233', component.options)
    }
    module.hot.accept("./OrganizationCreate.vue?vue&type=template&id=723e6233&", function () {
      api.rerender('723e6233', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/OrganizationCreate.vue"
export default component.exports